import { ref } from "vue";

export const useHelpers = () => {
    const phoneWithoutZero = (phone) => {
        return phone[0] === '0' 
            ? phone.slice(1) 
            : phone
    }

    const countries = ref([
        {
            code: "NG",
            name: "Nigeria",
            dialCode: "+234",
            flag: "https://flagcdn.com/w40/ng.png",
        },
        {
            code: "KE",
            name: "Kenya",
            dialCode: "+254",
            flag: "https://flagcdn.com/w40/ke.png",
        },
    ]);

    return {
        phoneWithoutZero,
        countries
    }
}